module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-10.1088300d.png";